import {Coin} from './coin'
export {Coin}

export const quartz = new Coin({
  symbol: 'QTZ',
  weiSymbol: 'wei',
  decimals: 18,
})

export const unique = new Coin({
  symbol: 'UNQ',
  weiSymbol: 'wei',
  decimals: 18,
})

export const opal = new Coin({
  symbol: 'OPL',
  weiSymbol: 'wei',
  decimals: 18,
})
